import styled from "styled-components";
import { FONT_SIZE, MEDIA_QUERIES, COLORS } from "../Variables";

export const FooterContainer = styled.footer`
  background-color: ${COLORS.footerColor};
  margin-top: 40px;
  padding: 20px 0;
  section {
    display: flex;
    justify-content: center;
    padding: 20px 0 20px 20px;
    .footer-links {
      display: flex;
      flex-wrap: wrap;
      justify-content: stretch;
      margin: 0 auto;
      max-width: 960px;
      width: 100%;
      /* border-bottom: 1px solid ${COLORS.greyColor}; */
      padding-bottom: 1.5em;
      @media ${MEDIA_QUERIES.MOBILE} {
        display: grid;
        grid-template-columns: 50% 40%;
        grid-template-rows: 45% 55%;
        column-gap: 10%;
      }
      div {
        width: 25%;
        @media ${MEDIA_QUERIES.MOBILE} {
          width: auto;
          justify-content: center;
        }
        span {
          color: ${COLORS.footerFontColor};
          font-size: ${FONT_SIZE.small};
          font-weight: 700;
          line-height: 1.1;
          text-transform: uppercase;
          letter-spacing: 1.8px;
        }
        ul {
          margin: 5px 5px 5px 0;
          li,
          a {
            list-style: none;
            cursor: pointer;
            text-decoration: none;
            color: ${COLORS.footerFontColor};
            padding: 5px 0;
            transition: 0.2s ease-in-out;
            letter-spacing: 1px;
            line-height: 1.5;
            &:hover {
              color: ${(props) => props.lang === 'hazteoir' ? `${COLORS.hoOrangeHover}` : `${COLORS.linkColor}`};
            }
          }
        }
      }
      div:nth-child(1),
      div:nth-child(2) {
        margin-bottom: 30px;
      }
    }
  }
  .copy {
    display: flex;
    flex-direction: column;
    max-width: 960px;
    flex-wrap: wrap;
    justify-content: stretch;
    margin: 0 auto;
    padding: 0;
    @media ${MEDIA_QUERIES.TABLET} {
      justify-content: space-between;
    }
    select {
      display: none;
      @media ${MEDIA_QUERIES.TABLET} {
        display: block;
        align-self: flex-end;
        width: 90%;
        margin: 0 auto;
        padding: 10px;
      }
    }
    p {
      padding-top: 30px;
      margin: 30px 20px 0;
      color: ${COLORS.footerFontColor};
      font-size: ${FONT_SIZE.small};
      font-weight: 700;
      border-top: 1px solid ${COLORS.greyColor};
    }
  }
`;
